'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
  return window.innerWidth <= 991;
};

var addEventListenerStamped = exports.addEventListenerStamped = function addEventListenerStamped(el, eventName, handler) {
  if (el.addEventListener) {
    el.addEventListener(eventName, handler);
  } else {
    el.attachEvent('on' + eventName, function () {
      handler.call(el);
    });
  }
};